import { AuthModalSheet } from "@components/modals/AuthModal/AuthModalSheet";
import { useCallback } from "react";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";

export const useAuthSheet = () => {
  const bottomSheetManager = useBottomSheetManager();

  return useCallback(() => {
    bottomSheetManager.open(<AuthModalSheet />, {
      mode: "push",
    });
  }, [bottomSheetManager]);
};
